// extracted by mini-css-extract-plugin
export default {"otpWrapper":"OtpValidationForm_otpWrapper__TfRdY","otpMsg":"OtpValidationForm_otpMsg__GwBTp"};